import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LevelStoreModule } from "../components/level/store";

@NgModule({
  imports: [CommonModule, LevelStoreModule],
})
export class LevelsStoreModule {}
